import React from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'reactstrap';
import { generalActions } from '../../../actions/general.action';
import Backend from '../../Layouts/Backend';
import { Alert, Loading } from '../../UI/Common';

const Help = (props) => {
  const [isLoading, setLoading] = React.useState(false);
  const [isDownloading, setDownloading] = React.useState('');
  const [error, setError] = React.useState('');
  const [documents, setDocuments] = React.useState([]);
  React.useEffect(() => {
    setLoading(true);
    props
      .getHelpDocuments()
      .then((resp) => setDocuments(resp))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);
  async function handleClick(documentName) {
    setError('');
    setDownloading(documentName);
    await props
      .downloadHelpDocument(documentName)
      .catch((err) => setError(err))
      .finally(() => setDownloading(''));
  }
  if (isLoading) {
    return (
      <Backend>
        <Loading />
      </Backend>
    );
  }
  return (
    <Backend>
      <div className="content-inner">
        <Alert.Error text={error} />
        {documents.map((document) => (
          <div
            key={document.name}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <a
              onClick={() => handleClick(document.name)}
              className={`configure-item ${
                isDownloading === document.name ? 'incompleted' : ''
              }`}
              style={{ cursor: 'pointer' }}
            >
              {document.name}
            </a>
            {isDownloading === document.name ? (
              <Spinner style={{ width: 5, height: 5, marginLeft: 10 }} />
            ) : null}
          </div>
        ))}
      </div>
    </Backend>
  );
};

export default connect(null, generalActions)(Help);
